import isValid from 'date-fns/isValid';
import format from 'date-fns/format';
import {
  toWordsOrdinal
} from 'number-to-words';

/** capitalize first letter of string */
const capitalize = (value) => {
  if (!value) {
    return;
  }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const calculateDiffInDays = (departureTimeString) => {
  if (!departureTimeString) return null;

  const departureDate = new Date(departureTimeString);
  const currentDate = new Date();

  // Calculate the time difference in milliseconds
  const timeDiff = departureDate - currentDate;

  // Convert time difference from milliseconds to days
  const diffInDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  return diffInDays;
}

/** format a date in given format */
const formatDate = (value, dateFormat = 'do MMM yyyy') => {
  if (!value) {
    return;
  }

  value = value.toString();
  const parsedDate = Date.parse(value);

  const date = new Date(parsedDate);
  if (isValid(date)) {
    value = format(date, dateFormat);
  }

  return value;
}

const formatTime = (value, timeFormat = 'HH:mm') => {
  if (!value) {
    return;
  }
  value = value.toString();
  const parsedDate = Date.parse(value); 

  const date = new Date(parsedDate); 
  if (isValid(date)) {
    value = format(date, timeFormat);
  }
  
  return value; 
}

/** convert integer to ordinal word */
const numberToWordsOrdinal = (value, convertFirstToLead = true) => {
  if (value === 1 && convertFirstToLead) {
    return 'Lead';
  }
  return toWordsOrdinal(value);
}

/** get a nested state object from an array path */
const getNestedStateObject = (state, pathArray) => {
  let stateObject = state;
  for (let i = 0; i < pathArray.length; i++) {
    // return immediately when a value in path is undefined
    if (typeof stateObject === 'undefined' || !stateObject) {
      return null;
    }

    stateObject = stateObject[pathArray[i]];
  }
  return stateObject;
}

/** check an object for values (handles nested if needed) */
const objectHasValues = (object, deep = false, excludeKeys = []) => {
  if (!deep) {
    return Boolean(Object.values(object).filter(Boolean).length);
  }

  for (const key in object) {
    // we should not check excluded keys
    if (excludeKeys.length && excludeKeys.indexOf(key) > -1) {
      continue;
    }

    // check array
    if (Array.isArray(object[key])) {
      // TODO: check arrays for nested arrays and objects
      // currently doesnt check for arrays and objects (only key:values)
      if (object[key].filter(Boolean).length) {
        return true;
      }
    }

    // check nested object
    else if (typeof object[key] === 'object' && object[key] !== null) {
      if (objectHasValues(object[key], deep)) {
        return true;
      }
    }

    // check key:value for value
    else if (object[key]) {
      return true;
    }
  }

  return false;
}

/** get currency formatted for correct country and currency */
const currency = (amount, cultureCode, currency) => {
  try {
    const options = {
      style: 'currency',
      currency: currency
    };

    if (currency === 'GBP') {
      options.minimumFractionDigits = 2;
      options.maximumFractionDigits = 2,
      options.trailingZeroDisplay= 'stripIfInteger';
    }

    const formattedAmount = new Intl.NumberFormat(cultureCode, options).format(amount);
    const isCanadianDollar = currency === 'CAD';

    return isCanadianDollar ? `C${formattedAmount}` : formattedAmount;
  } catch (err) {
    return amount;
  }
}

/** get days remaining until a certain date */
const daysRemaining = (date) => {
  const today = new Date();
  const diffTime = Math.abs(date - today);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

/** scroll to an element */
const scrollToElement = (el, onlyScrollIfAboveViewport = false) => {
  const elementOffsetTop = $(el).offset().top;

  // only scroll to elements above your current position
  if (onlyScrollIfAboveViewport && $(window).scrollTop() < elementOffsetTop) {
    return;
  }

  $('html, body').animate({
    scrollTop: elementOffsetTop - 20
  }, 300);
}

/** get array of days */
const days = [];
for (let day = 1; day < 32; day++) {
  days.push(day);
}

/** get array of months */
const months = [];
for (let month = 1; month < 13; month++) {
  months.push(month);
}

/** get array of months with labels */
const monthOptions = [{
  value: 1,
  label: 'Jan'
}, {
  value: 2,
  label: 'Feb'
}, {
  value: 3,
  label: 'Mar'
}, {
  value: 4,
  label: 'Apr'
}, {
  value: 5,
  label: 'May'
}, {
  value: 6,
  label: 'Jun'
}, {
  value: 7,
  label: 'Jul'
}, {
  value: 8,
  label: 'Aug'
}, {
  value: 9,
  label: 'Sep'
}, {
  value: 10,
  label: 'Oct'
}, {
  value: 11,
  label: 'Nov'
}, {
  value: 12,
  label: 'Dec'
}];

/** get month name by month number */
const monthName = (monthNumber) => {
  const monthNameValue = monthOptions.find((month) => month.value === monthNumber);
  return monthNameValue.label;
};

/** get array of years */
const years = [];
for (let year = new Date().getFullYear(); year > 1900; year--) {
  years.push(year);
}

/** get array of departure years */
const departureYears = [];
const topYear = new Date().getFullYear() + 10;

for (let year = topYear; year > topYear - 21; year--) {
  departureYears.push(year);
}

/** get array of future years */
const futureYears = [];
const futurelastYear = new Date().getFullYear() + 30;

for (let futureYear = new Date().getFullYear(); futureYear < futurelastYear; futureYear++) {
  futureYears.push(futureYear);
}

export {
  capitalize,
  formatDate,
  formatTime,
  numberToWordsOrdinal,
  getNestedStateObject,
  objectHasValues,
  currency,
  daysRemaining,
  scrollToElement,
  calculateDiffInDays,
  days,
  months,
  monthOptions,
  monthName,
  years,
  departureYears,
  futureYears
}
